import { fa } from "./fa";
import { en } from "./en";
import { ar } from "./ar";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
    en: {
        translation: en,
    },
    fa: {
        translation: fa,
    },
    ar: {
        translation: ar,
    },
};

i18n.use(initReactI18next).init({
    resources,
    lng: localStorage.getItem("language"),
    fallbackLng: "en",
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;